import clsx from 'clsx'
import { forwardRef } from 'react'

import { useFormControl } from '@forms/index'

import useInputClass from '../input/Input.styles'
import { InputProps } from '../input/Input.types'

export const Textarea = forwardRef<HTMLElement, InputProps & { rows?: number }>(
  (props, ref) => {
    const {
      size = 'md',
      variant = 'outline',
      color = 'primary',
      as: Comp = 'textarea',
      'aria-label': ariaLabel,
      'aria-describedby': ariaDescribedby,
      className,
      type = 'text',
      id,
      rows = 4,
      ...rest
    } = props

    const { readOnly, disabled, invalid, required, ...formControl } =
      useFormControl(props)
    const classes = useInputClass({ size, variant, disabled, invalid })

    return (
      <Comp
        ref={ref}
        readOnly={readOnly}
        aria-readonly={readOnly}
        disabled={disabled}
        aria-disabled={disabled}
        aria-label={ariaLabel}
        aria-invalid={invalid}
        required={required}
        aria-required={required}
        aria-describedby={ariaDescribedby}
        data-color={color ? color : undefined}
        className={clsx(classes, className)}
        type={type}
        rows={rows}
        id={id || formControl.id}
        {...rest}
      />
    )
  }
)

Textarea.displayName = 'Textarea'
